import { lazy, Suspense } from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { RoleGuard } from '@portals/shared/guards/RoleGuard'
import { PortalLoginPage } from '@portals/shared/components/PortalLoginPage'
import { ToastProvider } from '@/components/feedback/ToastProvider'
import { DialogProvider, LoadingState } from '@/components/ui'

// KAN-1181: the authenticated console (assignments board, earnings, proof gallery,
// PortalHero) is the heavy part of this portal. Code-split it so the login screen ships
// without it. `DeliveryConsole` is still re-exported below so existing component tests
// (tests/components/DeliveryConsole.test.tsx) import it unchanged.
const DeliveryConsole = lazy(() =>
  import('./DeliveryConsole').then(m => ({ default: m.DeliveryConsole }))
)

// Re-export for direct-mount component tests (the test imports the real, non-lazy component).
export { DeliveryConsole } from './DeliveryConsole'

export function DeliveryPortal() {
  const renderDeliveryLogin = () => (
    <PortalLoginPage
      portal="delivery"
      title="Delivery Agent Login"
      description={[
        'Sign in to review your assignments, share live location updates, and record proof-of-delivery.',
        'Use the credentials provided by the dispatch operations team.'
      ]}
      scope="global"
      requestedScopes={['delivery:self', 'orders:self']}
      redirectPath="/"
      allowedRoles={['DELIVERY_AGENT', 'SUPER_ADMIN']}
    />
  )

  return (
    <Router>
      <ToastProvider>
        <DialogProvider>
        <Routes>
          <Route
            path="/login"
            element={renderDeliveryLogin()}
          />
          <Route
            path="/"
            element={
              <RoleGuard
                portal="delivery"
                allowedRoles={['DELIVERY_AGENT', 'SUPER_ADMIN']}
                requiredScopes={['delivery:self', 'orders:self']}
                fallback={renderDeliveryLogin()}
              >
                <Suspense fallback={<LoadingState label="Loading console…" />}>
                  <DeliveryConsole />
                </Suspense>
                </RoleGuard>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        </DialogProvider>
      </ToastProvider>
    </Router>
  )
}
